import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { UnboardingResourcePackage } from "../../../resources/UnboardingResourcePackage";

export class EarnPointsContainer extends Container {

    public constructor(unboardingResources: UnboardingResourcePackage) {
        super();
        const coinIcon = new Sprite(unboardingResources.assets_views_unboarding_token_icon_png);
        this.addChild(coinIcon);
        const earnText = new Text(`AND EARN`, new ContainerTextStyle());
        earnText.style.fill = ["#00f7ff", "#3381ff"];
        earnText.style.fillGradientType = 1;
        earnText.angle = -5;
        earnText.skew.x = -0.08;
        earnText.position.set(-102, 213);
        this.addChild(earnText);
        const pointsText = new Text(`OWN POINTS`, new ContainerTextStyle());
        pointsText.style.fontSize = 32;
        pointsText.angle = -5;
        pointsText.skew.x = -0.08;
        pointsText.position.set(9, 263);
        this.addChild(pointsText);
    }
}

class ContainerTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 78,
            fill: 'ffffff'
        });
    }
}